<template>
	<main id="page" class="garagedetail" ref="page">
		<div class="mobile__head">
			<span class="mobile__head__back" @click="closeDrawer">
				<span class="mobile__head__back__icon">
					<svg viewBox="0 0 50 50">
						<use xlink:href="#icon--back" width="100%" height="100%"></use>
					</svg>
				</span>
				<span class="mobile__head__back__label">
					{{ $t('common.back') }}
				</span>
			</span>
		</div>
		<template v-if="pageLoading">
			<Loading :isLoading="pageLoading" />
		</template>
		<template v-else>
			<div class="garagedetail__head">
				<div class="content">
					<div class="garagedetail__head__title">
						Garage
					</div>
				</div>
			</div>
			<div class="garagedetail__content">
				<div class="smallcontent">
					<div class="garagedetail__box">
						<GarageForm v-if="garage" :g="garage" :isCreate="false" />
					</div>
				</div>
			</div>
			<DeleteGarage :mode="editMode" />
			<Availability v-if="gid" :mode="editMode" :gid="gid" />
			<AvailabilityList v-if="gid" :mode="editMode" :gid="gid" />
			<LoadingModal :mode="editMode" />
			<template v-if="gid">
				<Single :mode="editMode" :gid="gid" />
				<Unique :mode="editMode" :gid="gid" />
			</template>
			<!-- <DeleteAvailabilities :mode="editMode" /> -->
		</template>
		<div class="modal__hint">
			<div class="modal__hint__box">
				<div class="modal__hint__box__head">
					<span class="modal__hint__box__head__close" @click="closeHint">
						<svg viewBox="0 0 50 50">
							<use xlink:href="#icon--close" width="100%" height="100%"></use>
						</svg>
					</span>
				</div>
				<div
					v-if="showHintSingle"
					class="modal__hint__box__content__single"
					v-html="$t('availabilities.hint.single')"
				>
				</div>
				<div
					v-if="showHintUnique"
					class="modal__hint__box__content__unique"
					v-html="$t('availabilities.hint.unique')"
				>					
				</div>
			</div>
		</div>
	</main>
</template>
<script>
import { EventBus } from '@/events_bus.js';
import { gsap } from 'gsap';
import { CustomEase } from 'gsap/all';
gsap.registerPlugin(CustomEase);

import Loading from '@/views/components/common/Loading';

import GarageForm from '@/views/components/garages/GarageForm';
import Availability from '@/views/components/garages/Availability';
import AvailabilityList from '@/views/components/garages/AvailabilityList';
import DeleteGarage from '@/views/components/garages/DeleteGarage';
import LoadingModal from '@/views/components/common/LoadingModal';
import Single from '@/views/components/garages/availabilities/Single';
import Unique from '@/views/components/garages/availabilities/Unique';
// import DeleteAvailabilities from '@/views/components/garages/DeleteAvailabilities';

export default {
	name: 'GarageDetail',
	components: {
		LoadingModal,
		Loading,
		GarageForm,
		Availability,
		AvailabilityList,
		DeleteGarage,
		Single,
		Unique
		// DeleteAvailabilities
	},
	data() {
		return {
			pageLoading: false,
			gid: null,
			editMode: 'mobile',
			garage: null,
			all: null,
			showHintSingle: false,
			showHintUnique: false,
		}
	},
	methods: {
		onResize() {
			this.wWidth = window.innerWidth;
			if(this.wWidth < 1200) {
				this.editMode = 'mobile'
			} else {
				this.editMode = 'desktop'
			}
		},
		closeDrawer() {
			this.$router.go(-1);
		},
		init() {
			this.pageLoading = true;
			this.$service.garages.detail.get(this.gid).then(res => {
				this.garage = {...res};
				this.pageLoading = false;
			}).catch(err => {
				this.$router.push({ name: 'garages.page' });
				console.error('ERR', err);
			});
		},
		closeHint() {
			console.log('CLOSE HINT');
			this.showHintSingle = false;
			this.showHintUnique = false;
			gsap.timeline({
				onComplete: () => {
					gsap.set('.modal__hint', {
						pointerEvents: 'none'
					})
				}
			})
			.to('.modal__hint__box', {
				duration: 0.3,
				y: 150,
				opacity: 0
			})
			.to('.modal__hint', {
				duration: 0.3,
				opacity: 0
			})
		}
	},
	mounted() {
		this.onResize();
		this.$nextTick(() => {
			window.addEventListener('resize', () => {
				this.onResize();
			});
		});
		this.gid = this.$route.params.id;
		if(this.gid) {
			this.init();
		} else {
			this.$router.push({ name: 'garages.page' });
		}
		
		EventBus.$on('open-hint-single', () => {
			this.showHintSingle = true;
			this.showHintUnique = false;
			gsap.timeline({
				onComplete: () => {
					gsap.set('.modal__hint', {
						pointerEvents: 'all'
					})
				}
			})
				.to('.modal__hint', {
					duration: 0.3,
					opacity: 1
				})
				.to('.modal__hint__box', {
					duration: 0.3,
					y: '0%',
					opacity: 1
				})
		});

		EventBus.$on('open-hint-unique', () => {
			this.showHintSingle = false;
			this.showHintUnique = true;
			gsap.timeline({
				onComplete: () => {
					gsap.set('.modal__hint', {
						pointerEvents: 'all'
					})
				}
			})
				.to('.modal__hint', {
					duration: 0.3,
					opacity: 1
				})
				.to('.modal__hint__box', {
					duration: 0.3,
					y: '0%',
					opacity: 1
				})
		});
	}
}
</script>
<style lang="scss">
.garagedetail {
	padding-top: var(--head);
	overflow: auto;
	.mobile__head {
		@extend %flexCenterBetween;
		@include size(100%, var(--head));
		padding: 0 var(--gutter);
		position: relative;
		&__back {
			@extend %flexCenterStart;
			width: calc(100% - var(--btn));
			cursor: pointer;
			&__icon {
				@extend %flexCenterCenter;
				@include size(var(--smallicon),var(--smallicon));
				svg {
					display: block;
					@include size(75%,75%);
					fill: $color-black;
				}
			}
			&__label {
				@extend %text-15;
				display: block;
				width: max-content;
				font-variation-settings: 'wght' 600;
				padding-left: var(--minigutter);
			}
		}
	}
	&__empty {
		@extend %flexCenterCenter;
		flex-direction: column;
		@include size(330px,100%);
		margin: 0 auto;
		margin-top: var(--supergutter);
		&__media {
			display: block;
			@include size(200px,220px);
			margin-bottom: var(--supergutter);
			&__image {
				display: block;
				@include size(100%,100%);
				object-fit: contain;
			}
		}
		&__title {
			@extend %text-25;
			font-family: $font-manrope;
			font-variation-settings: 'wght' 700;
			margin-bottom: var(--minigutter);
			text-align: center;
		}
		&__text {
			@extend %text-15;
			margin-bottom: var(--gutter);
			text-align: center;
		}
		&__add {
			@extend %btn;
			display: block;
			@include size(var(--addbtn),var(--addbtn));
			background: $color-white;
			border: 1px solid $color-blue;
			position: relative;
			padding: 0;
			box-shadow: $shadow;
			@extend %arrowClose;
			&:before,
			&:after {
				background: $color-blue;
				@include size(40%,3px);
			}
			&:before {
				transform: translate(-50%,-50%);
			}
			&:after {
				transform: translate(-50%,-50%) rotate(90deg);
			}
		}
	}
	&__content {
		display: block;
		width: 100%;
		margin: var(--supergutter) 0;
	}
	&__box {
		@extend %panel;
		@extend %flexCenterBetween;
		flex-wrap: wrap;
		width: 100%;
		padding: var(--gutter);
		background: transparent;
		box-shadow: none;
		&__head {
			@extend %flexCenterBetween;
			width: 100%;
			margin-bottom: var(--gutter);
			&__label, &__actions {
				width: 50%;
			}
			&__label {
				@extend %text-15;
				@extend %flexBaselineStart;
				width: 50%;
			}
		}
		&__content {
			width: 100%;
		}
	}
	&__headactions {
		@extend %flexCenterEnd;
		width: 100%;
	}
	&__toggle {
		@extend %flexCenterBetween;
		width: 100%;
		&__input {
			display: none;
		}
		&__label {
			@extend %text-15;
			display: block;
			font-family: $font-manrope;
			padding-right: var(--thirdgutter);
		}
		&__btn {
			display: block;
			@include size(48px,22px);
			border-radius: var(--minigutter);
			border: 1px solid $color-davy;
			position: relative;
			&:before {
				content: '';
				position: absolute;
				top: 50%;
				left: 2px;
				display: block;
				background: $color-blue;
				@include size(16px,16px);
				border-radius: 100%;
				transform: translateY(-50%);
				transition: 180ms linear;
				filter: grayscale(1);
			}
			&.on {
				&:before {
					left: calc(100% - 18px);
					filter: grayscale(0);
				}
			}
		}
	}
	&__availability {
		@extend %flexCenterCenter;
		background: $color-white;
		border: 1px solid $color-silver;
		border-radius: var(--minigutter);
		padding: 0 var(--thirdgutter);
		margin-right: var(--minigutter);
		&__icon {
			@extend %icon;
			svg {
				display: block;
				@include size(80%,80%);
				fill: $color-black;
			}
		}
		&__label {
			display: block;
			font-variation-settings: 'wght' 700;
			padding-left: var(--thirdgutter);
		}
	}
	&__share {
		@extend %icon;
		width: var(--btn);
		background: $color-white;
		box-shadow: $shadow;
		border: 1px solid $color-silver;
		svg {
			display: block;
			@include size(50%,50%);
			fill: $color-black;
		}
	}
	@media (min-width: $from-large) {
		.mobile__head {
			display: none;
		}
		&__head {
			display: none;
		}
		&__box {
			background: $color-white;
			box-shadow: $shadow;
		}
		&__toggle {
			width: 220px;
		}
	}
	@media (max-width: $to-large) {
		position: fixed;
		top: 0;
		left: 0;
		display: block;
		background: $color-antiflash !important;
		padding-top: 0;
		z-index: 100000;
		&__head {
			display: none;
		}
		&__box {
			border-radius: 0;
			box-shadow: none;
			padding: 0;
			&__head {
				.garagedetail {
					&__toggle,
					&__availability { display: none; }
				}
			}
		}
		&__content {
			margin-top: 0;
		}
	}
}
.modal__hint {
	@extend %flexCenterCenter;
	position: fixed;
	top: 0;
	left: 0;
	bottom: 0;
	right: 0;
	background: rgba($color-black, 0.8);
	z-index: 11000;
	overflow: hidden;
	opacity: 0;
	pointer-events: none;
	&__box {
		@extend  %panel;
		display: block;
		background: $color-seasalt;
		width: max-content;
		max-width: 90vw;
		max-height: 90vh;
		min-width: 300px;
		min-height: 300px;
		/*padding: var(--gutter);*/
		padding: 10px;
		overflow: hidden;
		&__head {
			@extend %flexCenterEnd;
			width: 100%;
			/*display: none;*/
			/*margin-bottom: var(--gutter);*/
			margin-bottom: 10px;
			&__title {
				@extend %text-33;
				display: block;
				width: 100%;
				font-family: $font-manrope;
				font-variation-settings: 'wght' 700;
			}
			&__close {
				@extend %icon;
				cursor: pointer;
				svg {
					@include size(70%,70%);
					fill: $color-black;
				}
			}
		}
		&__content__single,
		&__content__unique {
			display: block;
			width: 100%;
			padding-bottom: var(--gutter);
			b {
				font-variation-settings: "wght" 900;
			}
			.modal__hint {
				&__stars {
					@extend %flexCenterCenter;
					width: 100%;
					text-align: center;
					margin-bottom: var(--minigutter);
					.star {
						@extend %icon;
						margin: 0 var(--thirdgutter);
						fill: rgba($color-silver, 0.5);
						&.active {
							fill: $color-blue;
						}
					}
				}
				&__name, &__date,
				&__text {
					display: block;
					width: 100%;
					text-align: center;
				}
				&__name, &__date {
					margin-bottom: var(--minigutter);
				}
				&__name {
					@extend %text-20;
					font-family: $font-manrope;
					font-variation-settings: 'wght' 700;
					color: $color-black;
				}
				&__date {
					@extend %text-13;
					color: $color-silver;
				}
				&__text {
					@extend %text-13;
					max-height: 360px;
					overflow: auto;
				}
			}
		}
	}
	&__label {
		display: block;
		width: 100%;
		&__text {
			display: block;
			width: 100%;
		}
	}
	.errors {
		display: block;
		width: 100%;
		color: $color-error;
		text-transform: uppercase;
	}
	.actions {
		@extend %flexCenterBetween;
		flex-wrap: wrap;
	}
	&__button {
		width: 100%;
		text-align: center;
		margin-bottom: var(--gutter);
		&.filled {
			background: $color-blue;
			color: $color-white;
			order: 2;
		}
		&.outline {
			border-color: $color-blue;
			color: $color-blue;
			order: 1;
		}
	}
	&__loading {
		position: absolute;
		top: 0;
		left: 0;
		@extend %flexCenterCenter;
		background: rgba($color-white, 0.86);
		@include size(100%,100%);
		pointer-events: all;
		z-index: 100;
		&__spinner {
			display: block;
			margin-bottom: var(--gutter);
			&__box {
				display: block;
				@include size(65px,65px);
				margin: 0 auto var(--gutter);
			}
			&__label {
				@extend %text-15;
				display: block;
				width: 100%;
				font-family: $font-manrope;
				font-variation-settings: 'wght' 600;
				text-align: center;
			}
		}
		&__success {
			display: block;
			@extend %text-33;
			color: $color-green;
			font-variation-settings: 'wght' 700;
			text-align: center;
		}
	}
	.input-box {
		display: block;
		width: 100%;
		position: relative;
		.show-psw {
			position: absolute;
			top: 50%;
			right: var(--thirdgutter);
			display: block;
			@include size(var(--smallicon),var(--smallicon));
			transform: translateY(-50%);
			cursor: pointer;
			&__show,
			&__hide {
				position: absolute;
				top: 0;
				left: 0;
				display: flex;
				@extend %flexCenterCenter;
				@include size(100%,100%);
				pointer-events: none;
				svg {
					display: block;
					@include size(100%,100%);
					fill: $color-black;
				}
			}
			&__hide {
				display: none;
			}
			&.show {
				.show-psw__show {
					display: none;
				}
				.show-psw__hide {
					display: block;
				}
			}
		}
	}
	.changepswform {
		display: block;
		width: 100%;
		margin: var(--supergutter) 0;
	}
	@media (min-width: $from-large) {
		display: flex;
		background: rgba($color-black, 0.1);
		transform: translateX(0%);
		opacity: 0;
		/*&__head {
			display: none;
		}*/
		&__box {
			background: $color-white;
			max-height: 90vh;
			max-width: 780px;
			padding: var(--gutter);
			transform: translateY(150px);
			opacity: 0;
			&__head {
				display: flex;
				margin-bottom: var(--thirdgutter);
			}
			&__text {
				font-size: 0.938rem;
			}
		}
		&__button {
			margin-bottom: 0;
			&.filled {
				order: 2;
			}
			&.outline {
				order: 1;
			}
		}
	}
}
</style>
